namespace GeniuzPOS.Purchase {
    export class ListAppCreditNoteColumns {
        static columnsKey = 'Purchase.ListAppCreditNote';
    }
}
